var WarmupQuestions = require("lib/academic/WarmupQuestions");

class NonFictionMainIdeasQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionMainIdeasQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [MAIN_IDEA_1_STAGE];
		}

		if (!answers[MAIN_IDEA_1]) {
			return [MAIN_IDEA_1_STAGE];
		}

		if (this.props.level != "3") {
			return [MAIN_IDEA_1_STAGE, true];
		}

		if (!answers[MAIN_IDEA_2]) {
			return [MAIN_IDEA_2_STAGE];
		}

		return [MAIN_IDEA_2_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var mainIdea1Display = (
			<div>
				{ this.props.getTextF("label1", MAIN_IDEA_1_STAGE) }
				{ this.props.renderInputF(MAIN_IDEA_1) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var mainIdea2Display = (
				<div>
					{ this.props.getTextF("label1", MAIN_IDEA_2_STAGE) }
					{ this.props.renderInputF(MAIN_IDEA_2) }
				</div>
			);
		}

		return (
			<div>
				{ mainIdea1Display }
				{ mainIdea2Display }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionMainIdeasQuestion.STEM = "nfmain";

// stages
var MAIN_IDEA_1_STAGE = "mainidea1";
var MAIN_IDEA_2_STAGE = "mainidea2";

var STAGES = [
	MAIN_IDEA_1_STAGE, MAIN_IDEA_2_STAGE
];

// answer keys
var MAIN_IDEA_1 = "main_idea_1";
var MAIN_IDEA_2 = "main_idea_2";

NonFictionMainIdeasQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionMainIdeasQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionMainIdeasQuestion.js